import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { api_routes, db_tables } from '@app/consts';
import { BuySellService } from '@app/modules/time-off/services/buy-sell.service';
import { GridState } from '@app/shared/services/grid-state/grid-state.model';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { SortDescriptor } from '@progress/kendo-data-query';

@Component({
  selector: 'app-buy-sell-plan-publish-history-dialog',
  templateUrl: './buy-sell-plan-publish-history-dialog.component.html',
  styleUrls: ['./buy-sell-plan-publish-history-dialog.component.scss']
})
export class BuySellPlanPublishHistoryDialogComponent implements OnInit {
  public gridDataResult: GridDataResult;
  public api_routes = api_routes;
  public db_tables = db_tables;
  isLoading: boolean = true;
  pageSize: number = 20;
  skip: number = 0;
  buySellPlanId: string;
  getRequest: any;
  searchFilterString: string;
  sort: SortDescriptor[] = [{ field: "publishedOn", dir: "desc" }]; 
  sortString: string = 'publishedOn-desc';
  filterString: string;
  searchValue: string;
  gridId: string;

  public columns: any[] = [
    { field: "plan", subField: "name", title: "Buy Sell Plan" },
    { field: "publishedOn", title: "Published On", type: "dateTime" },
    { field: "publishedBy", title: "Published By", type: "employee" },
    { field: "startedAt", title: "Started At", type: "dateTime" },
    { field: "completedAt", title: "Completed At", type: "dateTime" }
  ];

  filterCategories: any[] = [
    { field: "publishedOn", title: "Published On", type: "Date", dataType: 'Date' },
    { field: "publishedBy.firstName", title: "Published By First Name", type: "String", dataType: 'String' },
    { field: "publishedBy.lastName", title: "Published By Last Name", type: "String", dataType: 'String' },
    { field: "startedAt", title: "Started At", type: "Date", dataType: 'Date' },
    { field: "completedAt", title: "Completed At", type: "Date", dataType: 'Date' }
  ];

  sortableColumns: any[] = [
    { field: "publishedBy", sortValue: [ "publishedBy.firstName", "publishedBy.lastName" ] },
    { field: "publishedOn", sortValue: "publishedOn" },
    { field: "startedAt", sortValue: "startedAt" },
    { field: "completedAt", sortValue: "completedAt" }
  ];

  constructor(
    private buySellService: BuySellService,
    private dialogRef: MatDialogRef<BuySellPlanPublishHistoryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    this.buySellPlanId = data.buySellPlanId;
  }

  ngOnInit(): void {
    this.gridId = `buy-sell-plan-publish-history-${this.buySellPlanId}`;
    this.getBuySellPlanPublishHistory();
  }

  getBuySellPlanPublishHistory() {
    this.isLoading = true;

    // Always include plan.id filter
    let baseFilter = `(plan.id = "${this.buySellPlanId}")`;
    let combinedFilter = baseFilter;

    if (this.filterString && this.searchFilterString) {
      combinedFilter = `${baseFilter} AND (${this.filterString}) AND (${this.searchFilterString})`;
    } else if (this.filterString) {
      combinedFilter = `${baseFilter} AND (${this.filterString})`;
    } else if (this.searchFilterString) {
      combinedFilter = `${baseFilter} AND (${this.searchFilterString})`;
    }
    // Use combinedFilter in the service call

    this.getRequest = this.buySellService.getBuySellPlanPublishHistory(this.pageSize, this.skip, combinedFilter, this.sortString)
      .subscribe(
        {
          next: (v) => {
            this.gridDataResult = {
              data: v.data,
              total: v.total
            };
            this.isLoading = false;
          },
          error: (e) => this.isLoading = false,
          complete: () => this.isLoading = false
        }
      );
  }

  gridStateChange(gridState: GridState) {
      if (this.pageSize !== gridState.pageSize) {
        this.pageSize = gridState.pageSize;
      }
      if (this.skip !== gridState.skip) {
        this.skip = gridState.skip;
      }
      if (this.sortString !== gridState.sortString) {
        this.sortString = gridState.sortString;
      }
      if (this.filterString !== gridState.filter) {
        this.filterString = gridState.filter;
        this.skip = 0;
      }
  
      if (this.searchValue !== gridState.searchValue) {
        let variants = [];
        this.searchFilterString = '';
        this.searchValue = gridState.searchValue;
  
        if (this.searchValue !== null) {
          variants = this.searchValue.split(' ').filter(value => value);
        }
  
        variants.map(variant => {
          if (variant) {
            if (this.searchFilterString.length > 2) {
              this.searchFilterString += ' AND ';
            }
            this.searchFilterString += `(PublishedBy.firstName like "${variant}") OR (PublishedBy.lastName like "${variant}")`;
          }
        });
  
        this.skip = 0;
      }
  
      this.getRequest.unsubscribe();
      this.getBuySellPlanPublishHistory();
    }

  close() {
    this.dialogRef.close()
  }

}
